import React from "react";
import styles from "./style.module.scss";
import { Link } from "gatsby";

export default function Footer() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.section}>
          <h2>Customize</h2>
          <ul>
            <li>
              <Link to="/process" key="process">
                Process
              </Link>
            </li>
            <li>
              <Link to="/lookbook" key="lookbook">
                Lookbook
              </Link>
            </li>
            <li>
              <Link to="/new-order" key="new-order">
                Get Started
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h2>Campus Managers</h2>
          <ul>
            <li>
              <Link to="/campus-managers" key="campus-managers">
                Overview
              </Link>
            </li>
            <li>
              <Link to="/apply" key="apply">
                Join Our Team
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h2>Shop</h2>
          <ul>
            <li>
              <a
                href="https://shop.greekdressing.us/collections/all-products"
                key="all-products"
                target="_blank"
                rel="noopener noreferrer"
              >
                All Products
              </a>
            </li>
            <li>
              <a
                href="https://shop.greekdressing.us/collections"
                key="organizations"
                target="_blank"
                rel="noopener noreferrer"
              >
                Organizations
              </a>
            </li>
            <li>
              <a
                href="https://shop.greekdressing.us/collections/t-shirts"
                key="t-shirts"
                target="_blank"
                rel="noopener noreferrer"
              >
                T-Shirts
              </a>
            </li>
            <li>
              <a
                href="https://shop.greekdressing.us/collections/hoodies-sweatshirts"
                key="hoodies"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hoodies & Sweatshirts
              </a>
            </li>
            <li>
              <a
                href="https://shop.greekdressing.us/collections/headwear"
                key="headwear"
                target="_blank"
                rel="noopener noreferrer"
              >
                Headwear
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.section}>
          <h2>Connect</h2>
          <ul>
            <li>
              <a
                href="https://www.instagram.com/greekdressing.us/"
                key="instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/greekdressing.us/"
                key="facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/greek-dressing/"
                key="linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
